<template>
  <!-- eslint-disable max-len -->
  <svg
    width="368px"
    height="299px"
    viewBox="0 0 368 299"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="Link-Device-Copy-5"
        transform="translate(1.000000, 0.000000)"
      >
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.25"
          x="80.8"
          y="53.76"
          width="4.81"
          height="2.4"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.25"
          x="94.01"
          y="53.76"
          width="4.81"
          height="2.4"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.25"
          x="107.23"
          y="53.76"
          width="4.81"
          height="2.4"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.25"
          x="120.44"
          y="53.76"
          width="4.81"
          height="2.4"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.25"
          x="133.66"
          y="53.76"
          width="4.81"
          height="2.4"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.25"
          x="146.87"
          y="53.76"
          width="4.81"
          height="2.4"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.25"
          x="160.09"
          y="53.76"
          width="4.81"
          height="2.4"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.25"
          x="187.7"
          y="53.76"
          width="4.81"
          height="2.4"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.25"
          x="200.92"
          y="53.76"
          width="4.81"
          height="2.4"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.25"
          x="214.14"
          y="53.76"
          width="4.81"
          height="2.4"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.25"
          x="227.35"
          y="53.76"
          width="4.81"
          height="2.4"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.25"
          x="240.57"
          y="53.76"
          width="4.81"
          height="2.4"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.25"
          x="253.78"
          y="53.76"
          width="4.81"
          height="2.4"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.25"
          x="267"
          y="53.76"
          width="4.81"
          height="2.4"
        ></rect>
        <polygon
          id="Path"
          stroke="#000000"
          points="340.95 293.07 324.41 298.06 268.41 268.12 357.5 268.12"
        ></polygon>
        <ellipse
          id="Oval"
          stroke="#000000"
          cx="326.32"
          cy="282.47"
          rx="4.45"
          ry="4.37"
        ></ellipse>
        <ellipse
          id="Oval"
          stroke="#000000"
          cx="36.94"
          cy="16.13"
          rx="4.45"
          ry="4.37"
        ></ellipse>
        <polygon
          id="Path"
          stroke="#000000"
          stroke-width="2"
          points="281.27 31.4 281.27 86.13 72.54 86.13 72.54 31.4 6.69 31.4 0 31.4 0 268.12 12.73 268.12 12.73 213.4 254.54 213.4 254.54 268.12 365.27 268.12 365.27 31.4"
        ></polygon>
        <polyline
          id="Path"
          stroke="#000000"
          stroke-width="2"
          points="281.9 31.4 274.93 39.04 79.01 39.04 72.54 31.4"
        ></polyline>
        <polyline
          id="Path"
          stroke="#000000"
          stroke-width="2"
          points="13.27 268.54 21.3 259.54 246.82 259.54 254.27 268.54"
        ></polyline>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.5"
          x="158.63"
          y="86.76"
          width="14.45"
          height="26.84"
        ></rect>
        xt>
        <rect
          id="DOOR_1_LABEL"
          class="door-label"
          :fill="door1 || '#FFFFFF'"
          stroke="#000000"
          stroke-width="0.5"
          x="71.91"
          y="113.57"
          width="101.18"
          height="10.74"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.5"
          x="71.91"
          y="86.76"
          width="14.45"
          height="26.84"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.5"
          x="86.36"
          y="86.76"
          width="14.45"
          height="26.84"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.5"
          x="100.82"
          y="86.76"
          width="14.45"
          height="26.84"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.5"
          x="115.27"
          y="86.76"
          width="14.45"
          height="26.84"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.5"
          x="129.72"
          y="86.76"
          width="14.45"
          height="26.84"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.5"
          x="144.18"
          y="86.76"
          width="14.45"
          height="26.84"
        ></rect>
        <text
          id="DOOR-1"
          class="door-label-text"
          fill="#FFFFFF"
          font-family="Work Sans"
          font-size="11"
          font-weight="800"
        >
          <tspan
            x="100"
            y="125"
          >DOOR 1</tspan>
        </text>
        <rect
          id="DOOR_0_LABEL"
          class="door-label"
          :fill="door0 || '#FFFFFF'"
          stroke="#000000"
          stroke-width="0.5"
          x="180.09"
          y="113.57"
          width="101.18"
          height="10.74"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.5"
          x="180.09"
          y="86.76"
          width="14.45"
          height="26.84"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.5"
          x="194.54"
          y="86.76"
          width="14.45"
          height="26.84"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.5"
          x="209"
          y="86.76"
          width="14.45"
          height="26.84"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.5"
          x="223.45"
          y="86.76"
          width="14.45"
          height="26.84"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.5"
          x="237.9"
          y="86.76"
          width="14.45"
          height="26.84"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.5"
          x="252.36"
          y="86.76"
          width="14.45"
          height="26.84"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.5"
          x="266.81"
          y="86.76"
          width="14.45"
          height="26.84"
        ></rect>
        <text
          id="DOOR-0"
          class="door-label-text"
          fill="#FFFFFF"
          font-family="Work Sans"
          font-size="11"
          font-weight="800"
        >
          <tspan
            x="207"
            y="125"
          >DOOR 0</tspan>
        </text>
        <rect
          id="DOOR_3_LABEL"
          class="door-label"
          :fill="door3 || '#FFFFFF'"
          stroke="#000000"
          stroke-width="0.5"
          transform="translate(62.680000, 179.940000) rotate(180.000000) translate(-62.680000, -179.940000) "
          x="12.09"
          y="174.57"
          width="101.18"
          height="10.74"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.5"
          transform="translate(106.045000, 198.700000) rotate(180.000000) translate(-106.045000, -198.700000) "
          x="98.82"
          y="185.28"
          width="14.45"
          height="26.84"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.5"
          transform="translate(91.595000, 198.700000) rotate(180.000000) translate(-91.595000, -198.700000) "
          x="84.37"
          y="185.28"
          width="14.45"
          height="26.84"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.5"
          transform="translate(77.135000, 198.700000) rotate(180.000000) translate(-77.135000, -198.700000) "
          x="69.91"
          y="185.28"
          width="14.45"
          height="26.84"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.5"
          transform="translate(62.685000, 198.700000) rotate(180.000000) translate(-62.685000, -198.700000) "
          x="55.46"
          y="185.28"
          width="14.45"
          height="26.84"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.5"
          transform="translate(48.225000, 198.700000) rotate(180.000000) translate(-48.225000, -198.700000) "
          x="41"
          y="185.28"
          width="14.45"
          height="26.84"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.5"
          transform="translate(33.775000, 198.700000) rotate(180.000000) translate(-33.775000, -198.700000) "
          x="26.55"
          y="185.28"
          width="14.45"
          height="26.84"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.5"
          transform="translate(19.325000, 198.700000) rotate(180.000000) translate(-19.325000, -198.700000) "
          x="12.1"
          y="185.28"
          width="14.45"
          height="26.84"
        ></rect>
        <text
          id="DOOR-3-/-SENSORS-REAR"
          class="door-label-text"
          fill="#FFFFFF"
          font-family="Work Sans"
          font-size="11"
          font-weight="800"
        >
          <tspan
            x="40"
            y="182"
          >DOOR 3</tspan>
        </text>
        <rect
          id="DOOR_2_LABEL"
          class="door-label"
          :fill="door2 || '#FFFFFF'"
          stroke="#000000"
          stroke-width="0.5"
          transform="translate(169.590000, 179.940000) rotate(180.000000) translate(-169.590000, -179.940000) "
          x="119"
          y="174.57"
          width="101.18"
          height="10.74"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.5"
          transform="translate(212.955000, 198.700000) rotate(180.000000) translate(-212.955000, -198.700000) "
          x="205.73"
          y="185.28"
          width="14.45"
          height="26.84"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.5"
          transform="translate(198.495000, 198.700000) rotate(180.000000) translate(-198.495000, -198.700000) "
          x="191.27"
          y="185.28"
          width="14.45"
          height="26.84"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.5"
          transform="translate(247.315000, 198.700000) rotate(180.000000) translate(-247.315000, -198.700000) "
          x="240.09"
          y="185.28"
          width="14.45"
          height="26.84"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.5"
          transform="translate(232.865000, 198.700000) rotate(180.000000) translate(-232.865000, -198.700000) "
          x="225.64"
          y="185.28"
          width="14.45"
          height="26.84"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.5"
          transform="translate(184.035000, 198.700000) rotate(180.000000) translate(-184.035000, -198.700000) "
          x="176.81"
          y="185.28"
          width="14.45"
          height="26.84"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.5"
          transform="translate(169.595000, 198.700000) rotate(180.000000) translate(-169.595000, -198.700000) "
          x="162.37"
          y="185.28"
          width="14.45"
          height="26.84"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.5"
          transform="translate(155.135000, 198.700000) rotate(180.000000) translate(-155.135000, -198.700000) "
          x="147.91"
          y="185.28"
          width="14.45"
          height="26.84"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.5"
          transform="translate(140.685000, 198.700000) rotate(180.000000) translate(-140.685000, -198.700000) "
          x="133.46"
          y="185.28"
          width="14.45"
          height="26.84"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.5"
          transform="translate(126.225000, 198.700000) rotate(180.000000) translate(-126.225000, -198.700000) "
          x="119"
          y="185.28"
          width="14.45"
          height="26.84"
        ></rect>
        <text
          id="DOOR-2-/-SENSORS-FRONT"
          class="door-label-text"
          fill="#FFFFFF"
          font-family="Work Sans"
          font-size="11"
          font-weight="800"
        >
          <tspan
            x="145"
            y="182"
          >DOOR 2</tspan>
        </text>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.5"
          cx="89.01"
          cy="58.57"
          r="1.2"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.5"
          cx="102.22"
          cy="58.57"
          r="1.2"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.5"
          cx="115.44"
          cy="58.57"
          r="1.2"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.5"
          cx="128.65"
          cy="58.57"
          r="1.2"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.5"
          cx="141.87"
          cy="58.57"
          r="1.2"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.5"
          cx="155.08"
          cy="58.57"
          r="1.2"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.5"
          cx="83.2"
          cy="63.57"
          r="4.81"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.5"
          cx="96.42"
          cy="63.57"
          r="4.81"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.5"
          cx="109.63"
          cy="63.57"
          r="4.81"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.5"
          cx="122.85"
          cy="63.57"
          r="4.81"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.5"
          cx="136.06"
          cy="63.57"
          r="4.81"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.5"
          cx="149.28"
          cy="63.57"
          r="4.81"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.5"
          cx="162.49"
          cy="63.57"
          r="4.81"
        ></circle>
        <path
          id="Path"
          d="M82,65.64 C81.6398915,65.4297942 81.3402058,65.1301085 81.13,64.77 L80.2,64.77 L80.2,62.37 L81.13,62.37 C81.3402058,62.0098915 81.6398915,61.7102058 82,61.5 L82,58.94 C79.8765347,59.4752906 78.388407,61.3851049 78.388407,63.575 C78.388407,65.7648951 79.8765347,67.6747094 82,68.21 L82,65.64 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M84.4,58.94 L84.4,61.5 C84.7601085,61.7102058 85.0597942,62.0098915 85.27,62.37 L86.2,62.37 L86.2,64.77 L85.27,64.77 C85.0597942,65.1301085 84.7601085,65.4297942 84.4,65.64 L84.4,68.21 C86.5234653,67.6747094 88.011593,65.7648951 88.011593,63.575 C88.011593,61.3851049 86.5234653,59.4752906 84.4,58.94 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M95.21,65.64 C94.8498915,65.4297942 94.5502058,65.1301085 94.34,64.77 L93.41,64.77 L93.41,62.37 L94.34,62.37 C94.5502058,62.0098915 94.8498915,61.7102058 95.21,61.5 L95.21,58.94 C93.0865347,59.4752906 91.598407,61.3851049 91.598407,63.575 C91.598407,65.7648951 93.0865347,67.6747094 95.21,68.21 L95.21,65.64 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M97.62,58.94 L97.62,61.5 C97.9801085,61.7102058 98.2797942,62.0098915 98.49,62.37 L99.42,62.37 L99.42,64.77 L98.49,64.77 C98.2797942,65.1301085 97.9801085,65.4297942 97.62,65.64 L97.62,68.21 C99.7434653,67.6747094 101.231593,65.7648951 101.231593,63.575 C101.231593,61.3851049 99.7434653,59.4752906 97.62,58.94 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M108.43,65.64 C108.069891,65.4297942 107.770206,65.1301085 107.56,64.77 L106.63,64.77 L106.63,62.37 L107.56,62.37 C107.770206,62.0098915 108.069891,61.7102058 108.43,61.5 L108.43,58.94 C106.306535,59.4752906 104.818407,61.3851049 104.818407,63.575 C104.818407,65.7648951 106.306535,67.6747094 108.43,68.21 L108.43,65.64 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M110.83,58.94 L110.83,61.5 C111.190826,61.7126866 111.493204,62.0116282 111.71,62.37 L112.63,62.37 L112.63,64.77 L111.71,64.77 C111.493204,65.1283718 111.190826,65.4273134 110.83,65.64 L110.83,68.21 C112.953465,67.6747094 114.441593,65.7648951 114.441593,63.575 C114.441593,61.3851049 112.953465,59.4752906 110.83,58.94 L110.83,58.94 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M121.64,65.64 C121.279891,65.4297942 120.980206,65.1301085 120.77,64.77 L119.84,64.77 L119.84,62.37 L120.77,62.37 C120.980206,62.0098915 121.279891,61.7102058 121.64,61.5 L121.64,58.94 C119.516535,59.4752906 118.028407,61.3851049 118.028407,63.575 C118.028407,65.7648951 119.516535,67.6747094 121.64,68.21 L121.64,65.64 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M124.05,58.94 L124.05,61.5 C124.410109,61.7102058 124.709794,62.0098915 124.92,62.37 L125.85,62.37 L125.85,64.77 L124.92,64.77 C124.709794,65.1301085 124.410109,65.4297942 124.05,65.64 L124.05,68.21 C126.173465,67.6747094 127.661593,65.7648951 127.661593,63.575 C127.661593,61.3851049 126.173465,59.4752906 124.05,58.94 L124.05,58.94 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M134.86,65.64 C134.499891,65.4297942 134.200206,65.1301085 133.99,64.77 L133.06,64.77 L133.06,62.37 L134,62.37 C134.210206,62.0098915 134.509891,61.7102058 134.87,61.5 L134.87,58.94 C132.746535,59.4752906 131.258407,61.3851049 131.258407,63.575 C131.258407,65.7648951 132.746535,67.6747094 134.87,68.21 L134.86,65.64 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M137.26,58.94 L137.26,61.5 C137.620826,61.7126866 137.923204,62.0116282 138.14,62.37 L139.06,62.37 L139.06,64.77 L138.14,64.77 C137.923204,65.1283718 137.620826,65.4273134 137.26,65.64 L137.26,68.21 C139.383465,67.6747094 140.871593,65.7648951 140.871593,63.575 C140.871593,61.3851049 139.383465,59.4752906 137.26,58.94 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M148.08,65.64 C147.714797,65.4330481 147.411112,65.1328137 147.2,64.77 L146.27,64.77 L146.27,62.37 L147.2,62.37 C147.411112,62.0071863 147.714797,61.7069519 148.08,61.5 L148.08,58.94 C145.956535,59.4752906 144.468407,61.3851049 144.468407,63.575 C144.468407,65.7648951 145.956535,67.6747094 148.08,68.21 L148.08,65.64 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M150.48,58.94 L150.48,61.5 C150.840109,61.7102058 151.139794,62.0098915 151.35,62.37 L152.28,62.37 L152.28,64.77 L151.35,64.77 C151.139794,65.1301085 150.840109,65.4297942 150.48,65.64 L150.48,68.21 C152.603465,67.6747094 154.091593,65.7648951 154.091593,63.575 C154.091593,61.3851049 152.603465,59.4752906 150.48,58.94 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M161.29,65.64 C160.929891,65.4297942 160.630206,65.1301085 160.42,64.77 L159.49,64.77 L159.49,62.37 L160.42,62.37 C160.630206,62.0098915 160.929891,61.7102058 161.29,61.5 L161.29,58.94 C159.166535,59.4752906 157.678407,61.3851049 157.678407,63.575 C157.678407,65.7648951 159.166535,67.6747094 161.29,68.21 L161.29,65.64 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M163.69,58.94 L163.69,61.5 C164.052945,61.7099231 164.355943,62.009478 164.57,62.37 L165.5,62.37 L165.5,64.77 L164.57,64.77 C164.355943,65.130522 164.052945,65.4300769 163.69,65.64 L163.69,68.21 C165.813465,67.6747094 167.301593,65.7648951 167.301593,63.575 C167.301593,61.3851049 165.813465,59.4752906 163.69,58.94 L163.69,58.94 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M173.09,49.22 L73.18,49.22 L73.18,67.38 L77.18,67.38 C78.5108525,69.3955115 80.7647454,70.6081696 83.18,70.6081696 C85.5952546,70.6081696 87.8491475,69.3955115 89.18,67.38 L90.46,67.38 C91.7868165,69.3784244 94.0262207,70.5796496 96.425,70.5796496 C98.8237793,70.5796496 101.063183,69.3784244 102.39,67.38 L103.67,67.38 C104.999168,69.3783238 107.240003,70.5791059 109.64,70.5791059 C112.039997,70.5791059 114.280832,69.3783238 115.61,67.38 L116.89,67.38 C118.216817,69.3784244 120.456221,70.5796496 122.855,70.5796496 C125.253779,70.5796496 127.493183,69.3784244 128.82,67.38 L130.1,67.38 C131.429168,69.3783238 133.670003,70.5791059 136.07,70.5791059 C138.469997,70.5791059 140.710832,69.3783238 142.04,67.38 L143.32,67.38 C144.646817,69.3784244 146.886221,70.5796496 149.285,70.5796496 C151.683779,70.5796496 153.923183,69.3784244 155.25,67.38 L156.53,67.38 C157.860852,69.3955115 160.114745,70.6081696 162.53,70.6081696 C164.945255,70.6081696 167.199148,69.3955115 168.53,67.38 L173.14,67.38 L173.09,49.22 Z"
          stroke="#000000"
          stroke-width="0.75"
        ></path>
        <path
          id="Path"
          d="M170.49,67.38 L170.49,79.06 L164.89,79.06 L164.89,77.16 C166.239404,75.9469824 166.475164,73.9193107 165.440074,72.4290451 C164.404984,70.9387796 162.4226,70.451758 160.814785,71.2927284 C159.206969,72.1336989 158.476304,74.0397848 159.11,75.74 C159.322064,76.2852158 159.665581,76.7695745 160.11,77.15 L160.11,79.06 L151.7,79.06 L151.7,77.16 C153.049404,75.9469824 153.285164,73.9193107 152.250074,72.4290451 C151.214984,70.9387796 149.2326,70.451758 147.624785,71.2927284 C146.016969,72.1336989 145.286304,74.0397848 145.92,75.74 C146.13493,76.2836678 146.47799,76.767382 146.92,77.15 L146.92,79.06 L138.51,79.06 L138.51,77.16 C139.859404,75.9469824 140.095164,73.9193107 139.060074,72.4290451 C138.024984,70.9387796 136.0426,70.451758 134.434785,71.2927284 C132.826969,72.1336989 132.096304,74.0397848 132.73,75.74 C132.942064,76.2852158 133.285581,76.7695745 133.73,77.15 L133.73,79.06 L125.32,79.06 L125.32,77.16 C126.669404,75.9469824 126.905164,73.9193107 125.870074,72.4290451 C124.834984,70.9387796 122.8526,70.451758 121.244785,71.2927284 C119.636969,72.1336989 118.906304,74.0397848 119.54,75.74 C119.75493,76.2836678 120.09799,76.767382 120.54,77.15 L120.54,79.06 L112,79.06 L112,77.16 C113.349404,75.9469824 113.585164,73.9193107 112.550074,72.4290451 C111.514984,70.9387796 109.5326,70.451758 107.924785,71.2927284 C106.316969,72.1336989 105.586304,74.0397848 106.22,75.74 C106.432064,76.2852158 106.775581,76.7695745 107.22,77.15 L107.22,79.06 L98.82,79.06 L98.82,77.16 C100.149174,75.9378505 100.367367,73.9201298 99.3301869,72.4420868 C98.2930067,70.9640438 96.3213599,70.4829891 94.7200054,71.3172659 C93.1186509,72.1515427 92.3830523,74.0430234 93,75.74 C93.2113259,76.2856131 93.5549621,76.7701401 94,77.15 L94,79.06 L85.6,79.06 L85.6,77.16 C86.9494038,75.9469824 87.1851636,73.9193107 86.1500738,72.4290451 C85.1149839,70.9387796 83.1326002,70.451758 81.5247846,71.2927284 C79.916969,72.1336989 79.1863039,74.0397848 79.82,75.74 C80.0320644,76.2852158 80.3755812,76.7695745 80.82,77.15 L80.82,79.06 L75.82,79.06 L75.82,67.38 L73.22,67.38 L73.22,79.06 L73.22,79.06 L73.22,86.85 L173.13,86.85 L173.13,67.38 L170.49,67.38 Z"
          stroke="#000000"
          stroke-width="0.5"
        ></path>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.25"
          cx="83.2"
          cy="74.48"
          r="1.8"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.25"
          cx="96.42"
          cy="74.48"
          r="1.8"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.25"
          cx="109.63"
          cy="74.48"
          r="1.8"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.25"
          cx="122.85"
          cy="74.48"
          r="1.8"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.25"
          cx="136.06"
          cy="74.48"
          r="1.8"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.25"
          cx="149.28"
          cy="74.48"
          r="1.8"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.25"
          cx="162.49"
          cy="74.48"
          r="1.8"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.5"
          cx="195.91"
          cy="58.57"
          r="1.2"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.5"
          cx="209.13"
          cy="58.57"
          r="1.2"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.5"
          cx="222.34"
          cy="58.57"
          r="1.2"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.5"
          cx="235.56"
          cy="58.57"
          r="1.2"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.5"
          cx="248.78"
          cy="58.57"
          r="1.2"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.5"
          cx="261.99"
          cy="58.57"
          r="1.2"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.5"
          cx="190.11"
          cy="63.57"
          r="4.81"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.5"
          cx="203.32"
          cy="63.57"
          r="4.81"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.5"
          cx="216.54"
          cy="63.57"
          r="4.81"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.5"
          cx="229.75"
          cy="63.57"
          r="4.81"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.5"
          cx="242.97"
          cy="63.57"
          r="4.81"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.5"
          cx="256.18"
          cy="63.57"
          r="4.81"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.5"
          cx="269.4"
          cy="63.57"
          r="4.81"
        ></circle>
        <path
          id="Path"
          d="M188.91,65.64 C188.547055,65.4300769 188.244057,65.130522 188.03,64.77 L187.1,64.77 L187.1,62.37 L188,62.37 C188.214057,62.009478 188.517055,61.7099231 188.88,61.5 L188.88,58.94 C186.756535,59.4752906 185.268407,61.3851049 185.268407,63.575 C185.268407,65.7648951 186.756535,67.6747094 188.88,68.21 L188.91,65.64 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M191.31,58.94 L191.31,61.5 C191.670109,61.7102058 191.969794,62.0098915 192.18,62.37 L193.11,62.37 L193.11,64.77 L192.18,64.77 C191.969794,65.1301085 191.670109,65.4297942 191.31,65.64 L191.31,68.21 C193.433465,67.6747094 194.921593,65.7648951 194.921593,63.575 C194.921593,61.3851049 193.433465,59.4752906 191.31,58.94 L191.31,58.94 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M202.12,65.64 C201.759891,65.4297942 201.460206,65.1301085 201.25,64.77 L200.32,64.77 L200.32,62.37 L201.25,62.37 C201.460206,62.0098915 201.759891,61.7102058 202.12,61.5 L202.12,58.94 C199.996535,59.4752906 198.508407,61.3851049 198.508407,63.575 C198.508407,65.7648951 199.996535,67.6747094 202.12,68.21 L202.12,65.64 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M204.52,58.94 L204.52,61.5 C204.882945,61.7099231 205.185943,62.009478 205.4,62.37 L206.33,62.37 L206.33,64.77 L205.4,64.77 C205.185943,65.130522 204.882945,65.4300769 204.52,65.64 L204.52,68.21 C206.643465,67.6747094 208.131593,65.7648951 208.131593,63.575 C208.131593,61.3851049 206.643465,59.4752906 204.52,58.94 L204.52,58.94 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M215.34,65.64 C214.977055,65.4300769 214.674057,65.130522 214.46,64.77 L213.53,64.77 L213.53,62.37 L214.46,62.37 C214.674057,62.009478 214.977055,61.7099231 215.34,61.5 L215.34,58.94 C213.216535,59.4752906 211.728407,61.3851049 211.728407,63.575 C211.728407,65.7648951 213.216535,67.6747094 215.34,68.21 L215.34,65.64 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M217.74,58.94 L217.74,61.5 C218.100109,61.7102058 218.399794,62.0098915 218.61,62.37 L219.54,62.37 L219.54,64.77 L218.61,64.77 C218.399794,65.1301085 218.100109,65.4297942 217.74,65.64 L217.74,68.21 C219.863465,67.6747094 221.351593,65.7648951 221.351593,63.575 C221.351593,61.3851049 219.863465,59.4752906 217.74,58.94 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M228.55,65.64 C228.189891,65.4297942 227.890206,65.1301085 227.68,64.77 L226.75,64.77 L226.75,62.37 L227.68,62.37 C227.890206,62.0098915 228.189891,61.7102058 228.55,61.5 L228.55,58.94 C226.426535,59.4752906 224.938407,61.3851049 224.938407,63.575 C224.938407,65.7648951 226.426535,67.6747094 228.55,68.21 L228.55,65.64 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M231,58.94 L231,61.5 C231.365203,61.7069519 231.668888,62.0071863 231.88,62.37 L232.81,62.37 L232.81,64.77 L231.88,64.77 C231.668888,65.1328137 231.365203,65.4330481 231,65.64 L231,68.21 C233.123465,67.6747094 234.611593,65.7648951 234.611593,63.575 C234.611593,61.3851049 233.123465,59.4752906 231,58.94 L231,58.94 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M241.77,65.64 C241.409174,65.4273134 241.106796,65.1283718 240.89,64.77 L240,64.77 L240,62.37 L240.92,62.37 C241.136796,62.0116282 241.439174,61.7126866 241.8,61.5 L241.8,58.94 C239.676535,59.4752906 238.188407,61.3851049 238.188407,63.575 C238.188407,65.7648951 239.676535,67.6747094 241.8,68.21 L241.77,65.64 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M244.17,58.94 L244.17,61.5 C244.530109,61.7102058 244.829794,62.0098915 245.04,62.37 L246,62.37 L246,64.77 L245,64.77 C244.789794,65.1301085 244.490109,65.4297942 244.13,65.64 L244.13,68.21 C246.253465,67.6747094 247.741593,65.7648951 247.741593,63.575 C247.741593,61.3851049 246.253465,59.4752906 244.13,58.94 L244.17,58.94 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M255,65.64 C254.639891,65.4297942 254.340206,65.1301085 254.13,64.77 L253.2,64.77 L253.2,62.37 L254.13,62.37 C254.340206,62.0098915 254.639891,61.7102058 255,61.5 L255,58.94 C252.876535,59.4752906 251.388407,61.3851049 251.388407,63.575 C251.388407,65.7648951 252.876535,67.6747094 255,68.21 L255,65.64 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M257.39,58.94 L257.39,61.5 C257.750109,61.7102058 258.049794,62.0098915 258.26,62.37 L259.19,62.37 L259.19,64.77 L258.26,64.77 C258.049794,65.1301085 257.750109,65.4297942 257.39,65.64 L257.39,68.21 C259.513465,67.6747094 261.001593,65.7648951 261.001593,63.575 C261.001593,61.3851049 259.513465,59.4752906 257.39,58.94 L257.39,58.94 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M268.2,65.64 C267.839174,65.4273134 267.536796,65.1283718 267.32,64.77 L266.4,64.77 L266.4,62.37 L267.32,62.37 C267.536796,62.0116282 267.839174,61.7126866 268.2,61.5 L268.2,58.94 C266.076535,59.4752906 264.588407,61.3851049 264.588407,63.575 C264.588407,65.7648951 266.076535,67.6747094 268.2,68.21 L268.2,65.64 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M270.6,58.94 L270.6,61.5 C270.960109,61.7102058 271.259794,62.0098915 271.47,62.37 L272.4,62.37 L272.4,64.77 L271.47,64.77 C271.259794,65.1301085 270.960109,65.4297942 270.6,65.64 L270.6,68.21 C272.723465,67.6747094 274.211593,65.7648951 274.211593,63.575 C274.211593,61.3851049 272.723465,59.4752906 270.6,58.94 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M281,49.22 L180.09,49.22 L180.09,67.38 L184.09,67.38 C185.420852,69.3955115 187.674745,70.6081696 190.09,70.6081696 C192.505255,70.6081696 194.759148,69.3955115 196.09,67.38 L197.36,67.38 C198.689168,69.3783238 200.930003,70.5791059 203.33,70.5791059 C205.729997,70.5791059 207.970832,69.3783238 209.3,67.38 L210.58,67.38 C211.909168,69.3783238 214.150003,70.5791059 216.55,70.5791059 C218.949997,70.5791059 221.190832,69.3783238 222.52,67.38 L223.79,67.38 C225.119168,69.3783238 227.360003,70.5791059 229.76,70.5791059 C232.159997,70.5791059 234.400832,69.3783238 235.73,67.38 L237,67.38 C238.329168,69.3783238 240.570003,70.5791059 242.97,70.5791059 C245.369997,70.5791059 247.610832,69.3783238 248.94,67.38 L250.22,67.38 C251.546817,69.3784244 253.786221,70.5796496 256.185,70.5796496 C258.583779,70.5796496 260.823183,69.3784244 262.15,67.38 L263.43,67.38 C264.760852,69.3955115 267.014745,70.6081696 269.43,70.6081696 C271.845255,70.6081696 274.099148,69.3955115 275.43,67.38 L281,67.38 L281,49.22 Z"
          stroke="#000000"
          stroke-width="0.75"
        ></path>
        <path
          id="Path"
          d="M277.4,67.38 L277.4,79.06 L271.8,79.06 L271.8,77.16 C273.139323,75.9423891 273.366298,73.9196591 272.330148,72.4354909 C271.293998,70.9513228 269.316963,70.4672901 267.712369,71.3049314 C266.107776,72.1425726 265.37465,74.0413829 266,75.74 C266.212064,76.2852158 266.555581,76.7695745 267,77.15 L267,79.06 L258.59,79.06 L258.59,77.16 C259.939404,75.9469824 260.175164,73.9193107 259.140074,72.4290451 C258.104984,70.9387796 256.1226,70.451758 254.514785,71.2927284 C252.906969,72.1336989 252.176304,74.0397848 252.81,75.74 C253.021326,76.2856131 253.364962,76.7701401 253.81,77.15 L253.81,79.06 L245.4,79.06 L245.4,77.16 C246.749404,75.9469824 246.985164,73.9193107 245.950074,72.4290451 C244.914984,70.9387796 242.9326,70.451758 241.324785,71.2927284 C239.716969,72.1336989 238.986304,74.0397848 239.62,75.74 C239.832064,76.2852158 240.175581,76.7695745 240.62,77.15 L240.62,79.06 L232.21,79.06 L232.21,77.16 C233.559404,75.9469824 233.795164,73.9193107 232.760074,72.4290451 C231.724984,70.9387796 229.7426,70.451758 228.134785,71.2927284 C226.526969,72.1336989 225.796304,74.0397848 226.43,75.74 C226.641326,76.2856131 226.984962,76.7701401 227.43,77.15 L227.43,79.06 L219.02,79.06 L219.02,77.16 C220.369404,75.9469824 220.605164,73.9193107 219.570074,72.4290451 C218.534984,70.9387796 216.5526,70.451758 214.944785,71.2927284 C213.336969,72.1336989 212.606304,74.0397848 213.24,75.74 C213.452064,76.2852158 213.795581,76.7695745 214.24,77.15 L214.24,79.06 L205.83,79.06 L205.83,77.16 C207.154074,75.9356018 207.367876,73.9204115 206.330193,72.4454418 C205.292509,70.970472 203.323571,70.4909023 201.723843,71.3234834 C200.124114,72.1560646 199.387275,74.04386 200,75.74 C200.211326,76.2856131 200.554962,76.7701401 201,77.15 L201,79.06 L192.59,79.06 L192.59,77.16 C193.939404,75.9469824 194.175164,73.9193107 193.140074,72.4290451 C192.104984,70.9387796 190.1226,70.451758 188.514785,71.2927284 C186.906969,72.1336989 186.176304,74.0397848 186.81,75.74 C187.02493,76.2836678 187.36799,76.767382 187.81,77.15 L187.81,79.06 L182.81,79.06 L182.81,67.38 L180.22,67.38 L180.22,79.06 L180.22,79.06 L180.22,86.85 L281,86.85 L281,67.38 L277.4,67.38 Z"
          stroke="#000000"
          stroke-width="0.5"
        ></path>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.25"
          cx="190.11"
          cy="74.48"
          r="1.8"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.25"
          cx="203.32"
          cy="74.48"
          r="1.8"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.25"
          cx="216.54"
          cy="74.48"
          r="1.8"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.25"
          cx="229.75"
          cy="74.48"
          r="1.8"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.25"
          cx="242.97"
          cy="74.48"
          r="1.8"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.25"
          cx="256.18"
          cy="74.48"
          r="1.8"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.25"
          cx="269.4"
          cy="74.48"
          r="1.8"
        ></circle>
        <path
          id="Path"
          d="M180.09,66.4 L180.09,85.49"
          stroke="#000000"
          stroke-width="0.75"
        ></path>
        <path
          id="Path"
          d="M173.09,65.72 L173.09,86.76"
          stroke="#000000"
          stroke-width="0.75"
        ></path>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.5"
          cx="97.44"
          cy="241.68"
          r="1.2"
        ></circle>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.25"
          transform="translate(103.245000, 245.280000) rotate(180.000000) translate(-103.245000, -245.280000) "
          x="100.84"
          y="244.08"
          width="4.81"
          height="2.4"
        ></rect>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.5"
          cx="84.23"
          cy="241.68"
          r="1.2"
        ></circle>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.25"
          transform="translate(90.035000, 245.280000) rotate(180.000000) translate(-90.035000, -245.280000) "
          x="87.63"
          y="244.08"
          width="4.81"
          height="2.4"
        ></rect>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.5"
          cx="71.01"
          cy="241.68"
          r="1.2"
        ></circle>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.25"
          transform="translate(76.815000, 245.280000) rotate(180.000000) translate(-76.815000, -245.280000) "
          x="74.41"
          y="244.08"
          width="4.81"
          height="2.4"
        ></rect>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.5"
          cx="57.8"
          cy="241.68"
          r="1.2"
        ></circle>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.25"
          transform="translate(63.605000, 245.280000) rotate(180.000000) translate(-63.605000, -245.280000) "
          x="61.2"
          y="244.08"
          width="4.81"
          height="2.4"
        ></rect>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.5"
          cx="44.58"
          cy="241.68"
          r="1.2"
        ></circle>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.25"
          transform="translate(50.385000, 245.280000) rotate(180.000000) translate(-50.385000, -245.280000) "
          x="47.98"
          y="244.08"
          width="4.81"
          height="2.4"
        ></rect>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.5"
          cx="31.37"
          cy="241.68"
          r="1.2"
        ></circle>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.25"
          transform="translate(37.175000, 245.280000) rotate(180.000000) translate(-37.175000, -245.280000) "
          x="34.77"
          y="244.08"
          width="4.81"
          height="2.4"
        ></rect>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.5"
          cx="103.25"
          cy="236.67"
          r="4.81"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.5"
          cx="90.04"
          cy="236.67"
          r="4.81"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.5"
          cx="76.82"
          cy="236.67"
          r="4.81"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.5"
          cx="63.61"
          cy="236.67"
          r="4.81"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.5"
          cx="50.39"
          cy="236.67"
          r="4.81"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.5"
          cx="37.17"
          cy="236.67"
          r="4.81"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.5"
          cx="23.96"
          cy="236.67"
          r="4.81"
        ></circle>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.25"
          transform="translate(23.955000, 245.280000) rotate(180.000000) translate(-23.955000, -245.280000) "
          x="21.55"
          y="244.08"
          width="4.81"
          height="2.4"
        ></rect>
        <path
          id="Path"
          d="M104.45,234.6 C104.810826,234.812687 105.113204,235.111628 105.33,235.47 L106.25,235.47 L106.25,237.87 L105.33,237.87 C105.113204,238.228372 104.810826,238.527313 104.45,238.74 L104.45,241.31 C106.573465,240.774709 108.061593,238.864895 108.061593,236.675 C108.061593,234.485105 106.573465,232.575291 104.45,232.04 L104.45,234.6 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M102.05,241.31 L102.05,238.74 C101.689891,238.529794 101.390206,238.230109 101.18,237.87 L100.25,237.87 L100.25,235.47 L101.18,235.47 C101.390206,235.109891 101.689891,234.810206 102.05,234.6 L102.05,232 C99.9265347,232.535291 98.438407,234.445105 98.438407,236.635 C98.438407,238.824895 99.9265347,240.734709 102.05,241.27 L102.05,241.31 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M91.24,234.6 C91.6001085,234.810206 91.8997942,235.109891 92.11,235.47 L93,235.47 L93,237.87 L92.07,237.87 C91.8597942,238.230109 91.5601085,238.529794 91.2,238.74 L91.2,241.31 C93.3234653,240.774709 94.811593,238.864895 94.811593,236.675 C94.811593,234.485105 93.3234653,232.575291 91.2,232.04 L91.24,234.6 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M88.83,241.31 L88.83,238.74 C88.4698915,238.529794 88.1702058,238.230109 87.96,237.87 L87,237.87 L87,235.47 L88,235.47 C88.2102058,235.109891 88.5098915,234.810206 88.87,234.6 L88.87,232 C86.7465347,232.535291 85.258407,234.445105 85.258407,236.635 C85.258407,238.824895 86.7465347,240.734709 88.87,241.27 L88.83,241.31 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M78,234.6 C78.360826,234.812687 78.6632037,235.111628 78.88,235.47 L79.8,235.47 L79.8,237.87 L78.9,237.87 C78.6832037,238.228372 78.380826,238.527313 78.02,238.74 L78.02,241.31 C80.1823892,240.800646 81.7088196,238.868628 81.7040472,236.647064 C81.6992748,234.425501 80.1645576,232.500058 78,232 L78,234.6 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M75.62,241.31 L75.62,238.74 C75.2598915,238.529794 74.9602058,238.230109 74.75,237.87 L73.82,237.87 L73.82,235.47 L74.75,235.47 C74.9602058,235.109891 75.2598915,234.810206 75.62,234.6 L75.62,232 C73.4965347,232.535291 72.008407,234.445105 72.008407,236.635 C72.008407,238.824895 73.4965347,240.734709 75.62,241.27 L75.62,241.31 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M64.81,234.6 C65.1701085,234.810206 65.4697942,235.109891 65.68,235.47 L66.61,235.47 L66.61,237.87 L65.68,237.87 C65.4697942,238.230109 65.1701085,238.529794 64.81,238.74 L64.81,241.31 C66.9334653,240.774709 68.421593,238.864895 68.421593,236.675 C68.421593,234.485105 66.9334653,232.575291 64.81,232.04 L64.81,234.6 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M62.4,241.31 L62.4,238.74 C62.0398915,238.529794 61.7402058,238.230109 61.53,237.87 L60.6,237.87 L60.6,235.47 L61.53,235.47 C61.7402058,235.109891 62.0398915,234.810206 62.4,234.6 L62.4,232 C60.2765347,232.535291 58.788407,234.445105 58.788407,236.635 C58.788407,238.824895 60.2765347,240.734709 62.4,241.27 L62.4,241.31 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M51.59,234.6 C51.9501085,234.810206 52.2497942,235.109891 52.46,235.47 L53.39,235.47 L53.39,237.87 L52.46,237.87 C52.2497942,238.230109 51.9501085,238.529794 51.59,238.74 L51.59,241.31 C53.7134653,240.774709 55.201593,238.864895 55.201593,236.675 C55.201593,234.485105 53.7134653,232.575291 51.59,232.04 L51.59,234.6 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M49.19,241.31 L49.19,238.74 C48.8298915,238.529794 48.5302058,238.230109 48.32,237.87 L47.39,237.87 L47.39,235.47 L48.32,235.47 C48.5302058,235.109891 48.8298915,234.810206 49.19,234.6 L49.19,232 C47.0665347,232.535291 45.578407,234.445105 45.578407,236.635 C45.578407,238.824895 47.0665347,240.734709 49.19,241.27 L49.19,241.31 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M38.38,234.6 C38.7401085,234.810206 39.0397942,235.109891 39.25,235.47 L40.18,235.47 L40.18,237.87 L39.25,237.87 C39.0397942,238.230109 38.7401085,238.529794 38.38,238.74 L38.38,241.31 C40.5034653,240.774709 41.991593,238.864895 41.991593,236.675 C41.991593,234.485105 40.5034653,232.575291 38.38,232.04 L38.38,234.6 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M36,241.31 L36,238.74 C35.6398915,238.529794 35.3402058,238.230109 35.13,237.87 L34.2,237.87 L34.2,235.47 L35.13,235.47 C35.3402058,235.109891 35.6398915,234.810206 36,234.6 L36,232 C33.8765347,232.535291 32.388407,234.445105 32.388407,236.635 C32.388407,238.824895 33.8765347,240.734709 36,241.27 L36,241.31 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M25.16,234.6 C25.5201085,234.810206 25.8197942,235.109891 26.03,235.47 L27,235.47 L27,237.87 L26,237.87 C25.7897942,238.230109 25.4901085,238.529794 25.13,238.74 L25.13,241.31 C27.2534653,240.774709 28.741593,238.864895 28.741593,236.675 C28.741593,234.485105 27.2534653,232.575291 25.13,232.04 L25.16,234.6 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M22.76,241.31 L22.76,238.74 C22.399174,238.527313 22.0967963,238.228372 21.88,237.87 L21,237.87 L21,235.47 L21.92,235.47 C22.1367963,235.111628 22.439174,234.812687 22.8,234.6 L22.8,232 C20.6765347,232.535291 19.188407,234.445105 19.188407,236.635 C19.188407,238.824895 20.6765347,240.734709 22.8,241.27 L22.76,241.31 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M13.36,251 L113.27,251 L113.27,232.86 L109.27,232.86 C107.939148,230.844488 105.685255,229.63183 103.27,229.63183 C100.854745,229.63183 98.6008525,230.844488 97.27,232.86 L96,232.86 C94.6731835,230.861576 92.4337793,229.66035 90.035,229.66035 C87.6362207,229.66035 85.3968165,230.861576 84.07,232.86 L82.79,232.86 C81.4608322,230.861676 79.2199969,229.660894 76.82,229.660894 C74.4200031,229.660894 72.1791678,230.861676 70.85,232.86 L69.57,232.86 C68.2431835,230.861576 66.0037793,229.66035 63.605,229.66035 C61.2062207,229.66035 58.9668165,230.861576 57.64,232.86 L56.36,232.86 C55.0308322,230.861676 52.7899969,229.660894 50.39,229.660894 C47.9900031,229.660894 45.7491678,230.861676 44.42,232.86 L43.14,232.86 C41.8131835,230.861576 39.5737793,229.66035 37.175,229.66035 C34.7762207,229.66035 32.5368165,230.861576 31.21,232.86 L29.93,232.86 C28.5991475,230.844488 26.3452546,229.63183 23.93,229.63183 C21.5147454,229.63183 19.2608525,230.844488 17.93,232.86 L13.36,232.86 L13.36,251 Z"
          stroke="#000000"
          stroke-width="0.75"
        ></path>
        <path
          id="Path"
          d="M16,232.86 L16,221.18 L21.6,221.18 L21.6,223.08 C20.4671666,224.078312 20.0706235,225.673637 20.6042058,227.086162 C21.137788,228.498687 22.4900538,229.433399 24,229.433399 C25.5099462,229.433399 26.862212,228.498687 27.3957942,227.086162 C27.9293765,225.673637 27.5328334,224.078312 26.4,223.08 L26.4,221.17 L34.81,221.17 L34.81,223.07 C33.6866814,224.068508 33.2971878,225.657258 33.8313081,227.062099 C34.3654285,228.466939 35.7120489,229.395619 37.215,229.395619 C38.7179511,229.395619 40.0645715,228.466939 40.5986919,227.062099 C41.1328122,225.657258 40.7433186,224.068508 39.62,223.07 L39.62,221.16 L48,221.16 L48,223.06 C46.8671666,224.058312 46.4706235,225.653637 47.0042058,227.066162 C47.537788,228.478687 48.8900538,229.413399 50.4,229.413399 C51.9099462,229.413399 53.262212,228.478687 53.7957942,227.066162 C54.3293765,225.653637 53.9328334,224.058312 52.8,223.06 L52.8,221.15 L61.2,221.15 L61.2,223.05 C60.0766814,224.048508 59.6871878,225.637258 60.2213081,227.042099 C60.7554285,228.446939 62.1020489,229.375619 63.605,229.375619 C65.1079511,229.375619 66.4545715,228.446939 66.9886919,227.042099 C67.5228122,225.637258 67.1333186,224.048508 66.01,223.05 L66.01,221.14 L74.42,221.14 L74.42,223.04 C73.2871666,224.038312 72.8906235,225.633637 73.4242058,227.046162 C73.957788,228.458687 75.3100538,229.393399 76.82,229.393399 C78.3299462,229.393399 79.682212,228.458687 80.2157942,227.046162 C80.7493765,225.633637 80.3528334,224.038312 79.22,223.04 L79.22,221.13 L87.63,221.13 L87.63,223.03 C86.5066814,224.028508 86.1171878,225.617258 86.6513081,227.022099 C87.1854285,228.426939 88.5320489,229.355619 90.035,229.355619 C91.5379511,229.355619 92.8845715,228.426939 93.4186919,227.022099 C93.9528122,225.617258 93.5633186,224.028508 92.44,223.03 L92.44,221.12 L100.85,221.12 L100.85,223.02 C99.7171666,224.018312 99.3206235,225.613637 99.8542058,227.026162 C100.387788,228.438687 101.740054,229.373399 103.25,229.373399 C104.759946,229.373399 106.112212,228.438687 106.645794,227.026162 C107.179376,225.613637 106.782833,224.018312 105.65,223.02 L105.65,221.11 L110.65,221.11 L110.65,232.79 L113.24,232.79 L113.24,221.18 L113.24,221.18 L113.24,213.4 L13.36,213.4 L13.36,232.86 L16,232.86 Z"
          stroke="#000000"
          stroke-width="0.5"
        ></path>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.25"
          cx="103.25"
          cy="225.76"
          r="1.8"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.25"
          cx="90.04"
          cy="225.76"
          r="1.8"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.25"
          cx="76.82"
          cy="225.76"
          r="1.8"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.25"
          cx="63.61"
          cy="225.76"
          r="1.8"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.25"
          cx="50.39"
          cy="225.76"
          r="1.8"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.25"
          cx="37.17"
          cy="225.76"
          r="1.8"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.25"
          cx="23.96"
          cy="225.76"
          r="1.8"
        ></circle>
        <path
          id="Path"
          d="M113.27,233.84 L113.27,214.75"
          stroke="#000000"
          stroke-width="0.75"
        ></path>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.5"
          cx="204.35"
          cy="241.68"
          r="1.2"
        ></circle>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.25"
          transform="translate(210.155000, 245.280000) rotate(180.000000) translate(-210.155000, -245.280000) "
          x="207.75"
          y="244.08"
          width="4.81"
          height="2.4"
        ></rect>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.5"
          cx="191.14"
          cy="241.68"
          r="1.2"
        ></circle>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.25"
          transform="translate(196.945000, 245.280000) rotate(180.000000) translate(-196.945000, -245.280000) "
          x="194.54"
          y="244.08"
          width="4.81"
          height="2.4"
        ></rect>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.5"
          cx="177.92"
          cy="241.68"
          r="1.2"
        ></circle>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.25"
          transform="translate(183.735000, 245.280000) rotate(180.000000) translate(-183.735000, -245.280000) "
          x="181.33"
          y="244.08"
          width="4.81"
          height="2.4"
        ></rect>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.5"
          cx="164.71"
          cy="241.68"
          r="1.2"
        ></circle>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.25"
          transform="translate(170.505000, 245.280000) rotate(180.000000) translate(-170.505000, -245.280000) "
          x="168.1"
          y="244.08"
          width="4.81"
          height="2.4"
        ></rect>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.5"
          cx="151.49"
          cy="241.68"
          r="1.2"
        ></circle>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.25"
          transform="translate(157.295000, 245.280000) rotate(180.000000) translate(-157.295000, -245.280000) "
          x="154.89"
          y="244.08"
          width="4.81"
          height="2.4"
        ></rect>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.5"
          cx="138.28"
          cy="241.68"
          r="1.2"
        ></circle>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.25"
          transform="translate(144.075000, 245.280000) rotate(180.000000) translate(-144.075000, -245.280000) "
          x="141.67"
          y="244.08"
          width="4.81"
          height="2.4"
        ></rect>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.5"
          cx="210.16"
          cy="236.67"
          r="4.81"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.5"
          cx="196.94"
          cy="236.67"
          r="4.81"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.5"
          cx="183.73"
          cy="236.67"
          r="4.81"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.5"
          cx="170.51"
          cy="236.67"
          r="4.81"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.5"
          cx="157.3"
          cy="236.67"
          r="4.81"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.5"
          cx="144.08"
          cy="236.67"
          r="4.81"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.5"
          cx="130.87"
          cy="236.67"
          r="4.81"
        ></circle>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.25"
          transform="translate(130.865000, 245.280000) rotate(180.000000) translate(-130.865000, -245.280000) "
          x="128.46"
          y="244.08"
          width="4.81"
          height="2.4"
        ></rect>
        <path
          id="Path"
          d="M211.36,234.6 C211.720109,234.810206 212.019794,235.109891 212.23,235.47 L213.16,235.47 L213.16,237.87 L212.23,237.87 C212.019794,238.230109 211.720109,238.529794 211.36,238.74 L211.36,241.31 C213.483465,240.774709 214.971593,238.864895 214.971593,236.675 C214.971593,234.485105 213.483465,232.575291 211.36,232.04 L211.36,234.6 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M209,241.31 L209,238.74 C208.639174,238.527313 208.336796,238.228372 208.12,237.87 L207.19,237.87 L207.19,235.47 L208.12,235.47 C208.336796,235.111628 208.639174,234.812687 209,234.6 L209,232 C206.876535,232.535291 205.388407,234.445105 205.388407,236.635 C205.388407,238.824895 206.876535,240.734709 209,241.27 L209,241.31 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M198.14,234.6 C198.505203,234.806952 198.808888,235.107186 199.02,235.47 L200,235.47 L200,237.87 L199,237.87 C198.788888,238.232814 198.485203,238.533048 198.12,238.74 L198.12,241.31 C200.243465,240.774709 201.731593,238.864895 201.731593,236.675 C201.731593,234.485105 200.243465,232.575291 198.12,232.04 L198.14,234.6 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M195.74,241.31 L195.74,238.74 C195.379891,238.529794 195.080206,238.230109 194.87,237.87 L193.94,237.87 L193.94,235.47 L194.87,235.47 C195.080206,235.109891 195.379891,234.810206 195.74,234.6 L195.74,232 C193.616535,232.535291 192.128407,234.445105 192.128407,236.635 C192.128407,238.824895 193.616535,240.734709 195.74,241.27 L195.74,241.31 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.5"
          cx="241.26"
          cy="241.68"
          r="1.2"
        ></circle>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.25"
          transform="translate(247.065000, 245.280000) rotate(180.000000) translate(-247.065000, -245.280000) "
          x="244.66"
          y="244.08"
          width="4.81"
          height="2.4"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.25"
          transform="translate(233.845000, 245.280000) rotate(180.000000) translate(-233.845000, -245.280000) "
          x="231.44"
          y="244.08"
          width="4.81"
          height="2.4"
        ></rect>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.5"
          cx="247.07"
          cy="236.67"
          r="4.81"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.5"
          cx="233.85"
          cy="236.67"
          r="4.81"
        ></circle>
        <path
          id="Path"
          d="M248.27,234.6 C248.630109,234.810206 248.929794,235.109891 249.14,235.47 L250.07,235.47 L250.07,237.87 L249.14,237.87 C248.929794,238.230109 248.630109,238.529794 248.27,238.74 L248.27,241.31 C250.393465,240.774709 251.881593,238.864895 251.881593,236.675 C251.881593,234.485105 250.393465,232.575291 248.27,232.04 L248.27,234.6 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M245.87,241.31 L245.87,238.74 C245.504797,238.533048 245.201112,238.232814 244.99,237.87 L244.06,237.87 L244.06,235.47 L245,235.47 C245.211112,235.107186 245.514797,234.806952 245.88,234.6 L245.88,232 C243.756535,232.535291 242.268407,234.445105 242.268407,236.635 C242.268407,238.824895 243.756535,240.734709 245.88,241.27 L245.87,241.31 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M235.05,234.6 C235.410826,234.812687 235.713204,235.111628 235.93,235.47 L236.85,235.47 L236.85,237.87 L235.93,237.87 C235.713204,238.228372 235.410826,238.527313 235.05,238.74 L235.05,241.31 C237.173465,240.774709 238.661593,238.864895 238.661593,236.675 C238.661593,234.485105 237.173465,232.575291 235.05,232.04 L235.05,234.6 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M232.65,241.31 L232.65,238.74 C232.289891,238.529794 231.990206,238.230109 231.78,237.87 L230.85,237.87 L230.85,235.47 L231.78,235.47 C231.990206,235.109891 232.289891,234.810206 232.65,234.6 L232.65,232 C230.526535,232.535291 229.038407,234.445105 229.038407,236.635 C229.038407,238.824895 230.526535,240.734709 232.65,241.27 L232.65,241.31 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M184.93,234.6 C185.290109,234.810206 185.589794,235.109891 185.8,235.47 L186.73,235.47 L186.73,237.87 L185.8,237.87 C185.589794,238.230109 185.290109,238.529794 184.93,238.74 L184.93,241.31 C187.053465,240.774709 188.541593,238.864895 188.541593,236.675 C188.541593,234.485105 187.053465,232.575291 184.93,232.04 L184.93,234.6 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M182.53,241.31 L182.53,238.74 C182.167055,238.530077 181.864057,238.230522 181.65,237.87 L180.72,237.87 L180.72,235.47 L181.65,235.47 C181.864057,235.109478 182.167055,234.809923 182.53,234.6 L182.53,232 C180.406535,232.535291 178.918407,234.445105 178.918407,236.635 C178.918407,238.824895 180.406535,240.734709 182.53,241.27 L182.53,241.31 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M171.71,234.6 C172.072945,234.809923 172.375943,235.109478 172.59,235.47 L173.52,235.47 L173.52,237.87 L172.59,237.87 C172.375943,238.230522 172.072945,238.530077 171.71,238.74 L171.71,241.31 C173.833465,240.774709 175.321593,238.864895 175.321593,236.675 C175.321593,234.485105 173.833465,232.575291 171.71,232.04 L171.71,234.6 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M169.31,241.31 L169.31,238.74 C168.949891,238.529794 168.650206,238.230109 168.44,237.87 L167.51,237.87 L167.51,235.47 L168.44,235.47 C168.650206,235.109891 168.949891,234.810206 169.31,234.6 L169.31,232 C167.186535,232.535291 165.698407,234.445105 165.698407,236.635 C165.698407,238.824895 167.186535,240.734709 169.31,241.27 L169.31,241.31 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M158.5,234.6 C158.860109,234.810206 159.159794,235.109891 159.37,235.47 L160.3,235.47 L160.3,237.87 L159.37,237.87 C159.159794,238.230109 158.860109,238.529794 158.5,238.74 L158.5,241.31 C160.623465,240.774709 162.111593,238.864895 162.111593,236.675 C162.111593,234.485105 160.623465,232.575291 158.5,232.04 L158.5,234.6 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M156.1,241.31 L156.1,238.74 C155.737055,238.530077 155.434057,238.230522 155.22,237.87 L154.29,237.87 L154.29,235.47 L155.22,235.47 C155.434057,235.109478 155.737055,234.809923 156.1,234.6 L156.1,232 C153.976535,232.535291 152.488407,234.445105 152.488407,236.635 C152.488407,238.824895 153.976535,240.734709 156.1,241.27 L156.1,241.31 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M145.28,234.6 C145.642945,234.809923 145.945943,235.109478 146.16,235.47 L147.09,235.47 L147.09,237.87 L146.16,237.87 C145.945943,238.230522 145.642945,238.530077 145.28,238.74 L145.28,241.31 C147.403465,240.774709 148.891593,238.864895 148.891593,236.675 C148.891593,234.485105 147.403465,232.575291 145.28,232.04 L145.28,234.6 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M142.88,241.31 L142.88,238.74 C142.519891,238.529794 142.220206,238.230109 142.01,237.87 L141.08,237.87 L141.08,235.47 L142,235.47 C142.210206,235.109891 142.509891,234.810206 142.87,234.6 L142.87,232 C140.746535,232.535291 139.258407,234.445105 139.258407,236.635 C139.258407,238.824895 140.746535,240.734709 142.87,241.27 L142.88,241.31 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M132.07,234.6 C132.430109,234.810206 132.729794,235.109891 132.94,235.47 L133.87,235.47 L133.87,237.87 L132.94,237.87 C132.729794,238.230109 132.430109,238.529794 132.07,238.74 L132.07,241.31 C134.193465,240.774709 135.681593,238.864895 135.681593,236.675 C135.681593,234.485105 134.193465,232.575291 132.07,232.04 L132.07,234.6 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M129.67,241.31 L129.67,238.74 C129.304797,238.533048 129.001112,238.232814 128.79,237.87 L127.86,237.87 L127.86,235.47 L128.79,235.47 C129.001112,235.107186 129.304797,234.806952 129.67,234.6 L129.67,232 C127.546535,232.535291 126.058407,234.445105 126.058407,236.635 C126.058407,238.824895 127.546535,240.734709 129.67,241.27 L129.67,241.31 Z"
          stroke="#000000"
          stroke-width="0.25"
        ></path>
        <path
          id="Path"
          d="M120.27,251 L220.18,251 L220.18,232.86 L216.18,232.86 C214.849148,230.844488 212.595255,229.63183 210.18,229.63183 C207.764745,229.63183 205.510852,230.844488 204.18,232.86 L202.9,232.86 C201.570832,230.861676 199.329997,229.660894 196.93,229.660894 C194.530003,229.660894 192.289168,230.861676 190.96,232.86 L189.7,232.86 C188.370832,230.861676 186.129997,229.660894 183.73,229.660894 C181.330003,229.660894 179.089168,230.861676 177.76,232.86 L176.48,232.86 C175.150832,230.861676 172.909997,229.660894 170.51,229.660894 C168.110003,229.660894 165.869168,230.861676 164.54,232.86 L163.27,232.86 C161.940832,230.861676 159.699997,229.660894 157.3,229.660894 C154.900003,229.660894 152.659168,230.861676 151.33,232.86 L150.05,232.86 C148.720832,230.861676 146.479997,229.660894 144.08,229.660894 C141.680003,229.660894 139.439168,230.861676 138.11,232.86 L136.83,232.86 C135.5023,230.839994 133.247273,229.623653 130.83,229.623653 C128.412727,229.623653 126.1577,230.839994 124.83,232.86 L120.22,232.86 L120.27,251 Z"
          stroke="#000000"
          stroke-width="0.75"
        ></path>
        <path
          id="Path"
          d="M122.87,232.86 L122.87,221.18 L128.46,221.18 L128.46,223.08 C127.336681,224.078508 126.947188,225.667258 127.481308,227.072099 C128.015428,228.476939 129.362049,229.405619 130.865,229.405619 C132.367951,229.405619 133.714572,228.476939 134.248692,227.072099 C134.782812,225.667258 134.393319,224.078508 133.27,223.08 L133.27,221.17 L141.68,221.17 L141.68,223.07 C140.547167,224.068312 140.150624,225.663637 140.684206,227.076162 C141.217788,228.488687 142.570054,229.423399 144.08,229.423399 C145.589946,229.423399 146.942212,228.488687 147.475794,227.076162 C148.009376,225.663637 147.612833,224.068312 146.48,223.07 L146.48,221.16 L154.89,221.16 L154.89,223.06 C153.766681,224.058508 153.377188,225.647258 153.911308,227.052099 C154.445428,228.456939 155.792049,229.385619 157.295,229.385619 C158.797951,229.385619 160.144572,228.456939 160.678692,227.052099 C161.212812,225.647258 160.823319,224.058508 159.7,223.06 L159.7,221.15 L168.11,221.15 L168.11,223.05 C166.760596,224.263018 166.524836,226.290689 167.559926,227.780955 C168.595016,229.27122 170.5774,229.758242 172.185215,228.917272 C173.793031,228.076301 174.523696,226.170215 173.89,224.47 C173.672338,223.927817 173.329705,223.444705 172.89,223.06 L172.89,221.15 L181.29,221.15 L181.29,223.05 C180.166681,224.048508 179.777188,225.637258 180.311308,227.042099 C180.845428,228.446939 182.192049,229.375619 183.695,229.375619 C185.197951,229.375619 186.544572,228.446939 187.078692,227.042099 C187.612812,225.637258 187.223319,224.048508 186.1,223.05 L186.1,221.14 L194.51,221.14 L194.51,223.04 C193.160596,224.253018 192.924836,226.280689 193.959926,227.770955 C194.995016,229.26122 196.9774,229.748242 198.585215,228.907272 C200.193031,228.066301 200.923696,226.160215 200.29,224.46 C200.072338,223.917817 199.729705,223.434705 199.29,223.05 L199.29,221.14 L207.7,221.14 L207.7,223.04 C206.567167,224.038312 206.170624,225.633637 206.704206,227.046162 C207.237788,228.458687 208.590054,229.393399 210.1,229.393399 C211.609946,229.393399 212.962212,228.458687 213.495794,227.046162 C214.029376,225.633637 213.632833,224.038312 212.5,223.04 L212.5,221.13 L217.5,221.13 L217.5,232.81 L220.1,232.81 L220.1,221.18 L220.1,221.18 L220.1,213.4 L120.27,213.4 L120.27,232.86 L122.87,232.86 Z"
          stroke="#000000"
          stroke-width="0.5"
        ></path>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.25"
          cx="210.16"
          cy="225.76"
          r="1.8"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.25"
          cx="196.94"
          cy="225.76"
          r="1.8"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.25"
          cx="183.73"
          cy="225.76"
          r="1.8"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.25"
          cx="170.51"
          cy="225.76"
          r="1.8"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.25"
          cx="157.3"
          cy="225.76"
          r="1.8"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.25"
          cx="144.08"
          cy="225.76"
          r="1.8"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.25"
          cx="130.87"
          cy="225.76"
          r="1.8"
        ></circle>
        <path
          id="Path"
          d="M120.27,234.52 L120.27,213.48"
          stroke="#000000"
          stroke-width="0.75"
        ></path>
        <polyline
          id="Path"
          stroke="#000000"
          stroke-linecap="round"
          points="108.82 38.4 38.85 0.54 22.3 5.53 5.76 30.48 6.12 30.76 71.91 30.76"
        ></polyline>
        <path
          id="Path"
          d="M253.9,232.86 L253.14,232.86 C251.810832,230.861676 249.569997,229.660894 247.17,229.660894 C244.770003,229.660894 242.529168,230.861676 241.2,232.86 L239.92,232.86 C238.588485,230.861772 236.346217,229.661429 233.945,229.661429 C231.543783,229.661429 229.301515,230.861772 227.97,232.86 L224.63,232.86 L224.63,250.94 L253.9,250.94 L253.9,242.65"
          stroke="#000000"
          stroke-width="0.75"
        ></path>
        <path
          id="Path"
          d="M227,221.18 L231.6,221.18 L231.6,223.08 C230.476681,224.078508 230.087188,225.667258 230.621308,227.072099 C231.155428,228.476939 232.502049,229.405619 234.005,229.405619 C235.507951,229.405619 236.854572,228.476939 237.388692,227.072099 C237.922812,225.667258 237.533319,224.078508 236.41,223.08 L236.41,221.17 L244.82,221.17 L244.82,223.07 C243.687167,224.068312 243.290624,225.663637 243.824206,227.076162 C244.357788,228.488687 245.710054,229.423399 247.22,229.423399 C248.729946,229.423399 250.082212,228.488687 250.615794,227.076162 C251.149376,225.663637 250.752833,224.068312 249.62,223.07 L249.62,221.16 L253.95,221.16 L253.95,214 L224.63,214 L224.63,232.83 L227,232.83 L227,221.18 Z"
          stroke="#000000"
          stroke-width="0.5"
        ></path>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.25"
          cx="247.17"
          cy="225.76"
          r="1.8"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.25"
          cx="233.96"
          cy="225.76"
          r="1.8"
        ></circle>
        <circle
          id="Oval"
          stroke="#000000"
          stroke-width="0.25"
          cx="247.17"
          cy="225.76"
          r="1.8"
        ></circle>
        <path
          id="Path"
          d="M220.18,213.4 L220.18,233.12"
          stroke="#000000"
          stroke-width="0.75"
        ></path>
        <path
          id="Path"
          d="M224.63,214.03 L224.63,233.12"
          stroke="#000000"
          stroke-width="0.75"
        ></path>
        <g
          id="Group-26"
          transform="translate(131.000000, 134.000000)"
          stroke="#000000"
          stroke-width="0.5"
        >
          <circle
            id="Oval"
            cx="16.5"
            cy="16.5"
            r="16.5"
          ></circle>
          <path
            id="Shape"
            d="M9.30373528,8 L11.1140012,14.1959799 L11.1592578,14.1959799 C11.3773631,13.4312894 11.8300734,12.7542637 12.453598,12.2603015 C13.0664164,11.7658745 13.7707642,11.3970328 14.5263524,11.1748744 C15.1570945,10.9883461 15.8193905,10.9329355 16.4723883,11.0120603 C17.1750128,11.0956673 17.851224,11.330176 18.4546295,11.6994975 C19.164722,12.1258874 19.7806249,12.6921359 20.2648954,13.3638191 C20.86649,14.2072347 21.313894,15.1504368 21.5863895,16.1497487 C21.8944081,17.1353388 22.0321486,18.1661668 21.9936993,19.1979899 C21.9575656,20.0163273 21.7575057,20.8191031 21.4053629,21.558794 C21.1010537,22.196511 20.6626509,22.7611139 20.1200741,23.2140704 C19.6109197,23.6292682 19.0228009,23.9369762 18.3912702,24.118593 C17.5669597,24.3780763 16.7003273,24.4763513 15.8387952,24.4080402 C15.0633256,24.3575185 14.3328625,24.0262983 13.7841434,23.4763819 L13.7841434,23.4763819 L14.2457612,25.0502513 L11.0234879,26 L6,8.97688442 L9.30373528,8 Z M17.5585478,15.7427136 C17.324526,15.3242696 17.0180652,14.9506396 16.6534149,14.639196 C16.3201628,14.3619415 15.9264239,14.1667539 15.503896,14.0693467 C15.0423948,13.9606655 14.5597231,13.9825903 14.1099913,14.1326633 C13.6582478,14.2578663 13.2466351,14.4978118 12.9152158,14.8291457 C12.6154479,15.154095 12.3954346,15.5442778 12.2725714,15.9688442 C12.1371609,16.4292961 12.0850534,16.9101998 12.1186988,17.3889447 C12.1475736,17.9141685 12.2418303,18.4337496 12.39929,18.9356784 C12.5385337,19.4349076 12.7391943,19.914953 12.9966777,20.3648241 C13.2330324,20.7843156 13.5391146,21.1605428 13.9018107,21.4773869 C14.2396756,21.7638002 14.6393228,21.968133 15.0694322,22.0743719 C15.5274502,22.1819419 16.0061038,22.1631838 16.4542856,22.0201005 C16.9102162,21.893749 17.3251976,21.6505405 17.6581125,21.3145729 C17.9536745,20.9915152 18.1705157,20.6045598 18.2917055,20.1839196 C18.4265478,19.7233546 18.4786443,19.242553 18.4455781,18.7638191 C18.4176146,18.2451315 18.3264275,17.731791 18.1740382,17.2351759 C18.0252175,16.7163055 17.8187698,16.2157041 17.5585478,15.7427136 L17.5585478,15.7427136 Z"
            fill="#FFFFFF"
            fill-rule="nonzero"
          ></path>
          <circle
            id="Oval"
            fill="#FFFFFF"
            fill-rule="nonzero"
            cx="26"
            cy="18"
            r="3"
          ></circle>
        </g>
        <rect
          id="MAC_ADDRESS_BACKGROUND"
          :fill="macAddress"
          fill-rule="nonzero"
          x="335"
          y="185.2"
          width="20"
          height="73"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#000000"
          stroke-width="0.5"
          x="265.77"
          y="185.29"
          width="89.17"
          height="72.79"
        ></rect>
        <text
          id="MAC_ADDRESS_LABEL"
          fill="#FFFFFF"
          transform="translate(345.990000, 221.480000) rotate(-90.000000) translate(-345.990000, -221.480000) "
          font-family="HelveticaNeue, Helvetica Neue"
          font-size="7"
          font-weight="normal"
        >
          <tspan
            x="314"
            y="223.48"
          >a1:b2:c3:d1:e2:f3</tspan>
        </text>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="291.09"
          y="193.05"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="293.38"
          y="193.05"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="295.67"
          y="193.05"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="297.96"
          y="193.05"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="302.53"
          y="193.05"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="291.09"
          y="195.34"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="293.38"
          y="195.34"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="302.53"
          y="195.34"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="309.4"
          y="195.34"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="291.09"
          y="197.63"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="293.38"
          y="197.63"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="295.67"
          y="197.63"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="300.24"
          y="197.63"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="302.53"
          y="197.63"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="309.4"
          y="197.63"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="297.96"
          y="199.92"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="300.24"
          y="199.92"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="302.53"
          y="199.92"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="304.82"
          y="199.92"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="309.4"
          y="199.92"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="291.09"
          y="202.2"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="295.67"
          y="202.2"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="302.53"
          y="202.2"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="304.82"
          y="202.2"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="309.4"
          y="202.2"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="295.67"
          y="204.49"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="297.96"
          y="204.49"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="300.24"
          y="204.49"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="302.53"
          y="204.49"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="304.82"
          y="204.49"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="291.09"
          y="206.78"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="295.67"
          y="206.78"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="300.24"
          y="206.78"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="304.82"
          y="206.78"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="309.4"
          y="206.78"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="295.67"
          y="209.07"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="297.96"
          y="209.07"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="302.53"
          y="209.07"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="304.82"
          y="209.07"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="309.4"
          y="209.07"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="272.78"
          y="211.36"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="279.65"
          y="211.36"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="281.94"
          y="211.36"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="284.23"
          y="211.36"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="286.51"
          y="211.36"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="288.8"
          y="211.36"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="291.09"
          y="211.36"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="293.38"
          y="211.36"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="295.67"
          y="211.36"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="297.96"
          y="211.36"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="300.24"
          y="211.36"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="304.82"
          y="211.36"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="307.11"
          y="211.36"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="309.4"
          y="211.36"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="311.69"
          y="211.36"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="318.55"
          y="211.36"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="323.13"
          y="211.36"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="325.42"
          y="211.36"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="327.7"
          y="211.36"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="279.65"
          y="213.65"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="281.94"
          y="213.65"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="288.8"
          y="213.65"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="291.09"
          y="213.65"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="297.96"
          y="213.65"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="300.24"
          y="213.65"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="304.82"
          y="213.65"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="307.11"
          y="213.65"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="316.26"
          y="213.65"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="318.55"
          y="213.65"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="320.84"
          y="213.65"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="323.13"
          y="213.65"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="325.42"
          y="213.65"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="275.07"
          y="215.93"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="277.36"
          y="215.93"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="281.94"
          y="215.93"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="286.51"
          y="215.93"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="288.8"
          y="215.93"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="293.38"
          y="215.93"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="295.67"
          y="215.93"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="302.53"
          y="215.93"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="304.82"
          y="215.93"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="307.11"
          y="215.93"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="311.69"
          y="215.93"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="320.84"
          y="215.93"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="327.7"
          y="215.93"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="272.78"
          y="218.22"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="275.07"
          y="218.22"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="281.94"
          y="218.22"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="288.8"
          y="218.22"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="291.09"
          y="218.22"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="297.96"
          y="218.22"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="304.82"
          y="218.22"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="307.11"
          y="218.22"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="313.97"
          y="218.22"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="320.84"
          y="218.22"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="323.13"
          y="218.22"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="325.42"
          y="218.22"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="327.7"
          y="218.22"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="272.78"
          y="220.51"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="275.07"
          y="220.51"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="277.36"
          y="220.51"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="279.65"
          y="220.51"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="281.94"
          y="220.51"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="286.51"
          y="220.51"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="295.67"
          y="220.51"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="300.24"
          y="220.51"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="309.4"
          y="220.51"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="313.97"
          y="220.51"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="316.26"
          y="220.51"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="327.7"
          y="220.51"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="272.78"
          y="222.8"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="275.07"
          y="222.8"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="279.65"
          y="222.8"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="284.23"
          y="222.8"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="288.8"
          y="222.8"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="304.82"
          y="222.8"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="307.11"
          y="222.8"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="309.4"
          y="222.8"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="318.55"
          y="222.8"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="325.42"
          y="222.8"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="272.78"
          y="225.09"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="275.07"
          y="225.09"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="284.23"
          y="225.09"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="286.51"
          y="225.09"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="291.09"
          y="225.09"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="295.67"
          y="225.09"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="297.96"
          y="225.09"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="300.24"
          y="225.09"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="304.82"
          y="225.09"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="307.11"
          y="225.09"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="309.4"
          y="225.09"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="311.69"
          y="225.09"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="318.55"
          y="225.09"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="320.84"
          y="225.09"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="323.13"
          y="225.09"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="325.42"
          y="225.09"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="327.7"
          y="225.09"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="272.78"
          y="227.38"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="279.65"
          y="227.38"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="281.94"
          y="227.38"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="284.23"
          y="227.38"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="288.8"
          y="227.38"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="291.09"
          y="227.38"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="295.67"
          y="227.38"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="297.96"
          y="227.38"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="307.11"
          y="227.38"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="311.69"
          y="227.38"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="316.26"
          y="227.38"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="320.84"
          y="227.38"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="323.13"
          y="227.38"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="327.7"
          y="227.38"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="272.78"
          y="229.66"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="279.65"
          y="229.66"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="281.94"
          y="229.66"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="286.51"
          y="229.66"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="302.53"
          y="229.66"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="309.4"
          y="229.66"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="311.69"
          y="229.66"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="313.97"
          y="229.66"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="316.26"
          y="229.66"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="318.55"
          y="229.66"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="323.13"
          y="229.66"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="325.42"
          y="229.66"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="291.09"
          y="231.95"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="293.38"
          y="231.95"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="295.67"
          y="231.95"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="297.96"
          y="231.95"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="300.24"
          y="231.95"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="302.53"
          y="231.95"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="309.4"
          y="231.95"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="318.55"
          y="231.95"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="323.13"
          y="231.95"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="325.42"
          y="231.95"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="291.09"
          y="234.24"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="293.38"
          y="234.24"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="295.67"
          y="234.24"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="297.96"
          y="234.24"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="302.53"
          y="234.24"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="309.4"
          y="234.24"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="313.97"
          y="234.24"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="318.55"
          y="234.24"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="327.7"
          y="234.24"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="291.09"
          y="236.53"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="293.38"
          y="236.53"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="300.24"
          y="236.53"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="302.53"
          y="236.53"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="307.11"
          y="236.53"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="309.4"
          y="236.53"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="318.55"
          y="236.53"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="325.42"
          y="236.53"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="291.09"
          y="238.82"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="293.38"
          y="238.82"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="295.67"
          y="238.82"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="300.24"
          y="238.82"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="307.11"
          y="238.82"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="309.4"
          y="238.82"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="311.69"
          y="238.82"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="313.97"
          y="238.82"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="316.26"
          y="238.82"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="318.55"
          y="238.82"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="325.42"
          y="238.82"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="327.7"
          y="238.82"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="291.09"
          y="241.11"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="293.38"
          y="241.11"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="302.53"
          y="241.11"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="304.82"
          y="241.11"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="307.11"
          y="241.11"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="311.69"
          y="241.11"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="313.97"
          y="241.11"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="325.42"
          y="241.11"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="327.7"
          y="241.11"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="300.24"
          y="243.39"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="302.53"
          y="243.39"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="309.4"
          y="243.39"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="311.69"
          y="243.39"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="318.55"
          y="243.39"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="320.84"
          y="243.39"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="323.13"
          y="243.39"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="325.42"
          y="243.39"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="327.7"
          y="243.39"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="295.67"
          y="245.68"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="304.82"
          y="245.68"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="311.69"
          y="245.68"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="313.97"
          y="245.68"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="316.26"
          y="245.68"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="318.55"
          y="245.68"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="323.13"
          y="245.68"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="325.42"
          y="245.68"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="327.7"
          y="245.68"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="291.09"
          y="247.97"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="295.67"
          y="247.97"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="300.24"
          y="247.97"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="302.53"
          y="247.97"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="304.82"
          y="247.97"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="309.4"
          y="247.97"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="320.84"
          y="247.97"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="327.7"
          y="247.97"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          x="316.38"
          y="195.45"
          width="11.21"
          height="11.21"
        ></rect>
        <path
          id="Shape"
          d="M327.59,193.05 L314,193.05 L314,209.05 L330,209.05 L330,193.05 L327.59,193.05 Z M327.59,206.67 L316.38,206.67 L316.38,195.45 L327.59,195.45 L327.59,206.67 Z"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
        ></path>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="318.55"
          y="197.63"
          width="6.86"
          height="6.86"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="320.85"
          y="197.64"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="323.14"
          y="197.64"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="318.56"
          y="199.92"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="320.85"
          y="199.92"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="323.14"
          y="199.92"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="318.56"
          y="202.21"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="320.85"
          y="202.21"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          x="275.13"
          y="195.45"
          width="11.21"
          height="11.21"
        ></rect>
        <path
          id="Shape"
          d="M286.35,193.05 L272.73,193.05 L272.73,209.05 L288.73,209.05 L288.73,193.05 L286.35,193.05 Z M286.35,206.67 L275.13,206.67 L275.13,195.45 L286.35,195.45 L286.35,206.67 Z"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
        ></path>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="277.31"
          y="197.63"
          width="6.86"
          height="6.86"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="279.6"
          y="197.64"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="281.89"
          y="197.64"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="277.32"
          y="199.92"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="279.6"
          y="199.92"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="281.89"
          y="199.92"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="277.32"
          y="202.21"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="279.6"
          y="202.21"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          x="275.13"
          y="236.7"
          width="11.21"
          height="11.21"
        ></rect>
        <path
          id="Shape"
          d="M286.35,234.29 L272.73,234.29 L272.73,250.29 L288.73,250.29 L288.73,234.29 L286.35,234.29 Z M286.35,247.91 L275.13,247.91 L275.13,236.7 L286.35,236.7 L286.35,247.91 Z"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
        ></path>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="277.31"
          y="238.87"
          width="6.86"
          height="6.86"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="279.6"
          y="238.88"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="281.89"
          y="238.88"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="277.32"
          y="241.17"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="279.6"
          y="241.17"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="281.89"
          y="241.17"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="277.32"
          y="243.46"
          width="2.29"
          height="2.29"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#FFFFFF"
          stroke-width="0.2"
          fill="#000000"
          fill-rule="nonzero"
          x="279.6"
          y="243.46"
          width="2.29"
          height="2.29"
        ></rect>
        <g
          id="Group-11"
          transform="translate(171.000000, 136.000000)"
          stroke="#000000"
          stroke-width="0.5"
        >
          <polygon
            id="Fill-1"
            points="36 28.9777778 40.1874338 28.9840418 40.194872 23.7255779 41.9622546 21.8425056 45.8555135 28.9925429 51 29 45.0922924 18.7503356 50.7993135 12.3661447 45.5200638 12.3582401 40.2021644 18.6359433 40.2201036 6.00641312 36.0326699 6"
          ></polygon>
          <g id="Group-10">
            <path
              id="Fill-2"
              d="M25.559633,12.4659518 C32.3119266,12.4659518 31.9229358,20.100901 31.9229358,20.100901 L31.906789,28.9722513 L27.5117798,28.9659213 L27.5261651,19.2375254 C27.5261651,19.2375254 27.6146789,15.9989467 24.5321101,15.9989467 C21.3027523,15.9989467 21.3535413,19.1677487 21.3535413,19.1677487 L21.3406239,28.9567944 L17.0659817,28.9506117 L17.0897615,12.5277792 L21.2289174,12.5338147 L21.2255413,13.938033 C21.2255413,13.938033 22.3302752,12.4659518 25.559633,12.4659518"
            ></path>
            <polygon
              id="Fill-4"
              points="8.5554789 12.4850741 12.9054239 12.4914041 12.881644 28.9445614 8.53169908 28.9382315"
            ></polygon>
            <polygon
              id="Fill-6"
              points="4.28713394 28.9319898 1.46788991e-05 27.1495939 1.46788991e-05 1.82979695 4.28830826 0.0791979695"
            ></polygon>
            <path
              id="Fill-8"
              d="M13.3761468,7.68170254 C13.3761468,9.10446904 12.226055,10.2578447 10.8073394,10.2578447 C9.38862385,10.2578447 8.23853211,9.10446904 8.23853211,7.68170254 C8.23853211,6.25893604 9.38862385,5.10556041 10.8073394,5.10556041 C12.226055,5.10556041 13.3761468,6.25893604 13.3761468,7.68170254"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'LinkDevice',
  props: ['door0', 'door1', 'door2', 'door3', 'macAddress'],
}
</script>

<style lang="scss">
.door-label {
  transition: fill 0.5s;
  height: 15px;
}
</style>
